import { H2, H3, P1 } from '../../../styles/FontStyles';
import { Main, Section7Wrapper } from '../Home.styled';

import image from '../../../assets/images/sec8Img.png';
import { colors, lightTheme } from '../../../styles/GlobalStyles';
import { Div, Img } from '../../../styles/Styles';
import { InputComponent } from 'components/Input/Input';
import { Button } from 'components/Button/Button';
import { ArrowButtonWhiteIcon } from 'styles';
import { useState } from 'react';
import { AnimatedDiv } from 'components/Animation/Animation';
import { ErrorToast, SuccessToast } from 'components/Toasts/Toasts';
import Spinner from 'components/Spinner/Spinner';

const textStyle = {
  color: colors.primary,
  fontWeight: 'bold',
};

export const Section8 = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !name || !subject || !message)
      return ErrorToast('Please fill all fields.');
    setLoading(true);

    try {
      const response = await fetch(
        'https://faas-lon1-917a94a7.doserverless.co/api/v1/web/fn-eabaef99-d539-4da9-9e25-2b74d02ff2dc/default/united-one-transactional-email',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name, subject, email, message }),
        }
      );

      setLoading(false);

      if (response.ok) {
        SuccessToast('Your message has been sent.');
        setEmail('');
      } else {
        const data = await response.json();
        ErrorToast(`Error: ${data.message || 'Message failed to send'}`);
      }
    } catch (error: any) {
      ErrorToast(`Network Error: ${error.message}`);
      setLoading(false);
    }
  };

  return (
    <Section7Wrapper id='section8'>
      {loading && <Spinner fullscreen={true} transparent />}
      <Main>
        <AnimatedDiv>
          <H2 center mb='24' color={lightTheme.white}>
            Contact Us
          </H2>
          <P1 center mb='100' mbSM='50' color={lightTheme.white}>
            We're here to help you with any questions about your account or the
            activation process in United One.
          </P1>
        </AnimatedDiv>
        <AnimatedDiv $flex $center $columnSM $gap='150px' $gapSM='24px'>
          <Div $width='50%' $widthSM='100%'>
            <form onSubmit={handleSubmit}>
              <InputComponent
                label='Full Name*'
                placeholder='Enter your full name'
                type='text'
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setName(e.target.value)
                }
              />
              <InputComponent
                label='Email Address*'
                placeholder='Your contact email'
                type='email'
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.target.value)
                }
              />
              <InputComponent
                label='Subject*'
                placeholder='What is your inquiry about?'
                type='text'
                value={subject}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSubject(e.target.value)
                }
              />

              <InputComponent
                label='Message*'
                placeholder='Write your message'
                type='textarea'
                value={message}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setMessage(e.target.value)
                }
              />
              <Div $mt='40px'>
                <Button
                  $height='50px'
                  $width='100%'
                  type='submit'
                  $negative
                  disabled={loading}
                >
                  Send Message
                  <ArrowButtonWhiteIcon />
                </Button>
              </Div>
            </form>
          </Div>
          <Div $width='50%' $widthSM='100%'>
            <Img src={image} width='100%' alt='section4' />
          </Div>
        </AnimatedDiv>
      </Main>
    </Section7Wrapper>
  );
};
